import { render, staticRenderFns } from "./need-help.vue?vue&type=template&id=482248f3&scoped=true&"
import script from "./need-help.vue?vue&type=script&lang=ts&"
export * from "./need-help.vue?vue&type=script&lang=ts&"
import style0 from "./need-help.vue?vue&type=style&index=0&id=482248f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482248f3",
  null
  
)

export default component.exports